import I18n from 'I18n';
import { fromJS } from 'immutable';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { buildRequestErrorMetaObject } from 'conversations-error-reporting/error-actions/builders/buildRequestErrorMetaObject';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { SEND_DISCONNECTED_ACCOUNT_EMAIL } from '../access-control/constants/asyncActionTypes';
import { sendDisconnectedEmail } from '../email/client/sendDisconnectedEmail';
import { jsx as _jsx } from "react/jsx-runtime";
export const sendDisconnectedAccountEmail = createAsyncAction({
  requestFn: sendDisconnectedEmail,
  actionTypes: SEND_DISCONNECTED_ACCOUNT_EMAIL,
  toRecordFn: response => fromJS(response),
  // eslint-disable-next-line react/display-name
  successMetaActionCreator: () => {
    return {
      notification: {
        message: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `conversations-inbox-ui.alerts.SEND_RECONNECT_EMAIL_SUCCESS.description`
        }),
        type: 'success',
        titleText: I18n.text(`conversations-inbox-ui.alerts.SEND_RECONNECT_EMAIL_SUCCESS.title`)
      }
    };
  },
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type '{}'.
  failureMetaActionCreator: ({
    error
  }) => buildRequestErrorMetaObject({
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
    message: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `conversations-inbox-ui.alerts.SEND_RECONNECT_EMAIL_FAILED.description`
    }),
    titleText: I18n.text(`conversations-inbox-ui.alerts.SEND_RECONNECT_EMAIL_FAILED.title`),
    error
  })
});